// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const updateDisabled = isDisabled => ({
    isDisabled,
    type: actions.UPDATE_ADVANCED_CLAIM_SUMMARY_IS_PRINT_CLAIM_DISABLED
});



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/action-creators/is-print-claim-disabled.js